import styles from './customButton.scss';
import Enum from 'enum';

var buttonTypeEnum = new Enum({
    'sceSecondary': 'sceBtnSecondary', 'sceLight': 'sceBtnLight','sceLightMed':'sceBtnLightMed' , 'sceError': 'sceBtnError', 'sceBtnWhite' : 'sceBtnWhite', 'sceErrorDisabled' : 'sceBtnErrorDisabled','sceDisableButton':'sceBtnDisable','sceDisabledButtonMed': 'sceBtnDisabledMed'
});
const customButton = function (props) {
    const buttonTypeClass = styles[buttonTypeEnum.get(props.buttonType) + ''];
    const btnWithIcon = <img src={props.src} alt={props.alt} />;
    const buttonVal = props.buttonType === "sceError" ?<span> {props.value}  {btnWithIcon} </span> : props.value;
    return (
        <button type='button' onMouseOver={props.handleRefreshButtonOver} onMouseOut={props.handleRefreshButtonOut} disabled={props.isDisabled} className={[buttonTypeClass, styles.sceButton].join(' ')} id={props.id} onClick={props.onClick} onMouseDown={props.onMouseDown}>{buttonVal}</button>
    );
};
export default customButton;
customButton.defaultProps = {
    buttonType: 'sceBtnSecondary',
    isDisabled: false,
    id: '',
    name: ''
};

